import { makeStyles } from 'e100-react-components';

export const useStyles = makeStyles(({ spacing, typography }) => ({
  chip: {
    padding: 0,
    marginLeft: spacing(),
    height: spacing(2.25),
    minWidth: spacing(2.25),
    fontSize: typography.caption.fontSize,
    '& > *': {
      paddingLeft: spacing(0.5),
      paddingRight: spacing(0.5)
    }
  }
}));